import { createContext } from "react";

interface FormContextType {
  set: (name: string, value: any) => void;
  get: (name: string) => any;
  setError: (name: string, error: string) => void;
}

const FormContext = createContext<FormContextType>({
  set: () => {},
  get: () => {},
  setError: () => {},
});

export default FormContext;
